import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListOl, faFilePdf, faList, faFolderOpen } from "@fortawesome/pro-solid-svg-icons";
import AssetTypes from "../../../../../../enums/assetTypes";
import { type AssetToDropType } from "../../../../../../interfaces/assetToDropInfo";
import DesignerAssetCard from "components/cards/DesignerAssetCard/DesignerAssetCard";
import { Icon } from "semantic-ui-react";

type Props = {
  item: AssetToDropType;
  isDraggable: boolean;
};

function StaticAssetCard({ item, isDraggable }: Props) {
  if (item.cardType === AssetTypes.Video) {
    return (
      <DesignerAssetCard
        isDraggable={isDraggable}
        id={item.id}
        title={item.title}
        assetType={AssetTypes.Video}
        thumbnailUrl={item.thumbnailUrl}
        dataHookType="flow-designer-video-asset-card"
        dragNDropItemType={item.dragNDropItemType}
        durationInSeconds={item.durationInSeconds}
        visibility={item.visibility}
        publisher={item.publisher}
      />
    );
  }

  if (item.cardType === AssetTypes.EmbeddedVideo) {
    return (
      <DesignerAssetCard
        isDraggable={isDraggable}
        assetType={AssetTypes.EmbeddedVideo}
        id={item.id}
        title={item.title}
        thumbnailUrl={item.thumbnailUrl}
        dataHookType="flow-designer-embedded-video-asset-card"
        dragNDropItemType={item.dragNDropItemType}
        visibility={item.visibility}
        publisher={item.publisher}
      />
    );
  }

  if (item.cardType === AssetTypes.SCORM) {
    return (
      <DesignerAssetCard
        isDraggable={isDraggable}
        assetType={AssetTypes.SCORM}
        id={item.id}
        title={item.title}
        thumbnailUrl={item.thumbnailUrl || <FontAwesomeIcon icon={faFolderOpen} className="icon" size="lg" />}
        dataHookType="flow-designer-scorm-asset-card"
        dragNDropItemType={item.dragNDropItemType}
        visibility={item.visibility}
        publisher={item.publisher}
      />
    );
  }

  if (item.cardType === AssetTypes.Assessment) {
    return (
      <DesignerAssetCard
        isDraggable={isDraggable}
        assetType={AssetTypes.Assessment}
        id={item.id}
        title={item.title}
        thumbnailUrl={<FontAwesomeIcon icon={faListOl} size="lg" className="icon" />}
        dragNDropItemType={item.dragNDropItemType}
        dataHookType="flow-designer-assessment-asset-card"
        visibility={item.visibility}
        questionsCount={item.questionsCount}
        publisher={item.publisher}
      />
    );
  }

  if (item.cardType === AssetTypes.Survey) {
    return (
      <DesignerAssetCard
        isDraggable={isDraggable}
        assetType={AssetTypes.Survey}
        id={item.id}
        title={item.title}
        branchingQuestion={item.branchingQuestion}
        questionsCount={item.questionsCount}
        dataHookType="flow-designer-survey-asset-card"
        thumbnailUrl={<FontAwesomeIcon icon={faList} size="lg" className="icon" />}
        dragNDropItemType={item.dragNDropItemType}
        visibility={item.visibility}
        publisher={item.publisher}
      />
    );
  }

  if (item.cardType === AssetTypes.Pdf) {
    return (
      <DesignerAssetCard
        isDraggable={isDraggable}
        assetType={AssetTypes.Pdf}
        id={item.id}
        title={item.title}
        dataHookType="flow-designer-pdf-asset-card"
        thumbnailUrl={item.thumbnailUrl || <FontAwesomeIcon icon={faFilePdf} size="lg" className="icon" />}
        dragNDropItemType={item.dragNDropItemType}
        visibility={item.visibility}
        publisher={item.publisher}
      />
    );
  }

  if (item.cardType === AssetTypes.Link) {
    return (
      <DesignerAssetCard
        isDraggable={isDraggable}
        assetType={AssetTypes.Link}
        id={item.id}
        title={item.title}
        dataHookType="flow-designer-link-asset-card"
        thumbnailUrl={<Icon className="fa-link" size="big" />}
        dragNDropItemType={item.dragNDropItemType}
        visibility={item.visibility}
        publisher={item.publisher}
      />
    );
  }

  return null;
}

export default StaticAssetCard;
